<div class="message-header-wrapper">
  <msd-avatar class="avatar-image" [text]="initials" [src]="avatarUrl"></msd-avatar>
  <span class="user-name-text">{{name}}</span>
  <span class="time-text">{{formattedDate}}</span>
</div>
<div class="message-content-wrapper">
  <p *ngIf="message" class="message-content-text" [innerHTML]="formatMessage(message)"></p>
  <msd-audio-preview-cell *ngIf="audioUrl" [url]="audioUrl" class="message-content-audio"></msd-audio-preview-cell>
  <msd-image-preview-cell *ngIf="imageUrl" [src]="imageUrl" class="message-content-image"></msd-image-preview-cell>
  <span class="ephemeral-media-label" *ngIf="ephemeralMedia">média éphémère</span>
</div>
